export const downloadImage = (
	dataUrl: string,
	name = 'structure-chart',
	format: 'png' | 'jpg' = 'png'
) => {
	const a = document.createElement('a');

	a.setAttribute('download', `${name}.${format}`);
	a.setAttribute('href', dataUrl);
	a.click();
};
